/** Event agar lonceng update di tab yang sama / lintas tab tanpa refresh halaman. */
export const INBOX_CHANGED_EVENT = "videostreaming:inbox-changed"

export function emitInboxChanged(): void {
  window.dispatchEvent(new CustomEvent(INBOX_CHANGED_EVENT))
}

export function subscribeInboxChanged(handler: () => void): () => void {
  const wrapped = (): void => {
    handler()
  }
  window.addEventListener(INBOX_CHANGED_EVENT, wrapped)
  return () => window.removeEventListener(INBOX_CHANGED_EVENT, wrapped)
}
